const Landing = () => {
    return ( 
        <div className = "landing">
            <div className = "first">
                <h2>CAITLIN</h2>
            </div>
            
            <h2>RAYMOND</h2>
        </div>
     );
}
 
export default Landing;